import dayjs from 'dayjs';
import Grid from '@mui/material/Grid';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { TimeClock } from '@mui/x-date-pickers/TimeClock';

const today = dayjs();
const twoPM = dayjs().set('hour', 14).startOf('hour');
const threePM = dayjs().set('hour', 15).startOf('hour');

export default function ValidationBehaviorView() {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Grid
        container
        columns={{ xs: 1, lg: 2 }}
        spacing={4}
        sx={{ alignItems: 'center', justifyContent: 'center' }}
      >
        <Grid>
          <DateCalendar defaultValue={today} disableFuture />
        </Grid>
        <Grid>
          <TimeClock defaultValue={twoPM} maxTime={threePM} />
        </Grid>
      </Grid>
    </LocalizationProvider>
  );
}
